<template>
  <div class="group-field-item" v-if="item && item.length && !hidden(item[0])">
    <div v-if="item.length == 2" class="group-field-item__row">
      <div
        v-if="item[0].name == 'name' || item[0].name == 'full_name'"
        class="row-name"
      >
        <p>
          {{ formatHtml(item[0].value) || 'Нет данных' }}
        </p>
        <Tooltip content="Скопировать ссылку на кандидата">
          <CopyButton
            v-if="storeModule == 'candidate' && route"
            :text="route"
            iconName="Link"
            class="copy-button"
          />
        </Tooltip>
      </div>
      <Avatar
        v-if="item[1].name == 'photo' && !hidden(item[1])"
        shape="square"
        :showTitle="false"
        :avatarName="avatarName"
        class="row-photo"
        :initials="item[1].placeholder || ''"
        :url="item[1].value ? item[1].actions.link : ''"
      />
    </div>
    <div
      v-else-if="
        item.length == 1 &&
        item[0].name == 'communications' &&
        item[0].value &&
        item[0].value.length &&
        !hidden(item[0])
      "
    >
      <Contacts
        :key="updateContactsKey"
        :communications="{
          ...item[0],
          config: contactStructure
        }"
      />
    </div>
    <div
      v-else-if="
        item.length == 1 &&
        item[0].type == 'url' &&
        !item[0].name == 'created_candidate'
      "
      class="group-field-item__row"
    >
      <Link
        :target="item[0].value"
        :text="item[0].lbl"
        :hasLeftIcon="true"
        :disabled="!item[0].value.length"
        :href="item[0].value"
      />
    </div>
    <div
      v-else-if="
        item.length == 1 &&
        item[0].type == 'url' &&
        item[0].name == 'created_candidate'
      "
      class="group-field-item__row"
    >
      <div class="column column--left">Созданный кандидат</div>
      <Link
        :target="item[0].value"
        :text="item[0].lbl"
        :hasLeftIcon="item[0].hasLeftIcon"
        :disabled="!item[0].value.length"
        :href="item[0].value"
      />
    </div>
    <div v-else-if="item.length == 1" class="group-field-item__row">
      <div
        v-if="hasLabel(item[0])"
        class="column column--left"
        :title="
          item[0].lbl && item[0].lbl.length > 14 ? formatHtml(item[0].lbl) : ''
        "
      >
        {{ formatHtml(item[0].lbl) }}
      </div>
      <p v-if="item[0].name == 'name'" class="row-name">
        {{ formatHtml(item[0].value) || 'Нет данных' }}
      </p>
      <div
        v-else-if="
          (!!item[0].value && item[0].value.length) ||
          item[0].name == 'project_description_id'
        "
      >
        <VacancyProjectDescription
          v-if="item[0].name == 'project_description_id'"
          :item="item[0]"
          :readonly="readonlyMode"
          :openCollapse="openCollapse"
          @set-mode="val => (readonlyMode = val)"
          :class="[
            'column',
            hasLabel(item[0]) ? 'column--right' : '',
            isCollapse(item[0]) && !openCollapse ? 'column--collapsed' : ''
          ]"
        />
        <p
          v-else-if="item[0].type == 'text'"
          v-html="$sanitize(formatHtml(item[0].value))"
          :class="[
            'column',
            hasLabel(item[0]) ? 'column--right' : '',
            isCollapse(item[0]) && !openCollapse ? 'column--collapsed' : ''
          ]"
        ></p>

        <p
          v-else
          :class="[
            'column',
            hasLabel(item[0]) ? 'column--right' : '',
            isCollapse(item[0]) && !openCollapse ? 'column--collapsed' : ''
          ]"
        >
          {{ resultValue(item[0]) }}
        </p>
        <div
          class="flex-row"
          v-if="isCollapse(item[0]) && !!item[0].value && item[0].value.length"
          @click="openCollapse = !openCollapse"
        >
          <p>
            {{ openCollapse ? 'Закрыть' : 'Раскрыть' }}
          </p>
          <Icon
            :iconName="openCollapse ? 'SmallArrowUp' : 'SmallArrowDown'"
            iconColor="#0075DB"
            class="header-center__icon"
          />
        </div>
      </div>

      <div v-else class="column column--right column--grey">нет данных</div>
    </div>
  </div>
</template>

<script>
import Avatar from 'Elements/Avatar/Avatar';
import { mixin, form } from '@/utils/mixins';
import Icon from 'Elements/Icon/Icon';
import Link from 'Elements/Link/Link';
import { MODULE } from '@/utils/constants';
import Contacts from 'Parts/Candidate/Details/CandidateContacts';
import { plural, setContactData } from '@/utils/helpers';
import CopyButton from 'Elements/Button/CopyButton';
import Tooltip from 'Elements/Tooltip/Tooltip';
import VacancyProjectDescription from 'Parts/Vacancy/Details/VacancyProjectDescription';

export default {
  mixins: [mixin, form],
  props: {
    item: {
      type: Array,
      default: () => []
    },
    storeModule: String,
    avatarName: String,
    id: { type: String, default: '' },
    rowsCount: Number
  },
  data() {
    return {
      updateContactsKey: 0, // потом нужен для обновления контактов
      openCollapse: false,
      contactStructure: {
        priority: ['phone', 'email', 'telegram'],
        excluded: ['freelance', 'livejournal', 'icq'],
        value_type_list: {
          phone: 'Телефон',
          email: 'E-mail',
          telegram: 'Telegram',
          skype: 'Skype',
          facebook: 'Facebook',
          linkedin: 'LinkedIn',
          habr: 'Хабр.Карьера',
          site: 'Сайт'
        }
      },
      readonlyMode: true
    };
  },
  computed: {
    route() {
      return this.$route.meta.module == MODULE.CANDIDATES_MODULE
        ? window.location.href
        : window.location.origin + `/candidates/${this.id}`;
    }
  },
  methods: {
    contactLink(type, val) {
      return setContactData(type, val).link;
    },
    resultValue(currentItem) {
      if (
        Array.isArray(currentItem.value) &&
        currentItem.visual_value &&
        currentItem.visual_value.length
      ) {
        let names = currentItem.value.map(id =>
          this.formatHtml(
            currentItem.visual_value.find(obj => obj.id === id).name
          )
        );
        return names.join(', ');
      } else if (currentItem.options) {
        return (
          this.formatHtml(currentItem.options[currentItem.value]) ||
          this.formatHtml(currentItem.value)
        );
      } else if (currentItem.name == 'age') {
        return this.formatHtml(plural(currentItem.value));
      } else {
        return this.formatHtml(currentItem.value);
      }
    },
    hasLabel(field) {
      return (
        !field.detailview_visual_type ||
        (field.detailview_visual_type &&
          !(field.detailview_visual_type == 'no-label'))
      );
    },
    isCollapse(field) {
      return (
        field.detailview_visual_type &&
        field.detailview_visual_type == 'collapse'
      );
    }
  },

  components: {
    Avatar,
    Contacts,
    Icon,
    Link,
    VacancyProjectDescription,
    CopyButton,
    Tooltip
  }
};
</script>

<style lang="scss" scoped>
.group-field-item {
  width: 100%;

  .communication-row {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__row {
    position: relative;
    display: flex;

    .row-name {
      max-width: calc(100% - 144px - 24px);
      display: flex;

      p {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-weight: 700;
        font-family: 'Roboto Medium';
        font-size: 24px;
        line-height: 32px;
        color: $grey80;
      }

      .copy-button {
        align-self: flex-end;
        padding: 4px 0 4px 8px;
      }
    }

    .row-photo {
      position: absolute;
      right: 0;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
      margin-top: 4px;

      p {
        color: $blue64;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        margin-right: 4px;
      }
    }

    .column {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      display: flex;
      flex-direction: column;
      color: $grey80;

      & ::v-deep li {
        margin-left: 16px;
      }

      &__links {
        display: flex;
        width: auto;
        flex-direction: row;
        align-items: center;
        color: $blue64 !important;
        text-decoration: none !important;
        max-width: 260px;
        white-space: nowrap;

        svg,
        a {
          margin-right: 8px;
          text-overflow: ellipsis;
          overflow: hidden;
          text-decoration: none !important;
        }
      }

      &--left {
        width: 140px;
        color: $grey40;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 16px;
        display: block;
        white-space: wrap;
        min-width: 140px;
      }

      &--right {
        color: $grey80;
        max-width: 400px;
      }

      &--collapsed {
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &--blue {
        color: $blue64;
        margin-left: 8px;
        text-decoration: none;
      }

      &--grey {
        color: $grey40;
      }
    }
  }
}
</style>
